import React from "react";

import Button from "react-bootstrap/Button";
import { Col, Row, Image, InputGroup, Form, Container, Card } from "react-bootstrap";

function Features() {
  const InfoCol = (props: { title: any; children: any }) => {
    return (
      <Col sm={12} md={12} lg={4}>
        <Card style={{ marginBottom: 40, minHeight: 450 }}>
          <Card.Body
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <h4>{props.title}</h4>
            <p>{props.children}</p>
          </Card.Body>
        </Card>
      </Col>
    );
  };

  return (
    <Container style={{ marginTop: 100, padding: 20 }}>
      <Row className={"justify-content-center"}>
        <InfoCol title={"AI-Powered Contract Analysis"}>
          Simply upload or scan your legal documents. Our intelligent AI reads and analyzes the
          text, identifying key clauses, obligations, and potential areas of concern quickly and
          efficiently.
        </InfoCol>

        <InfoCol title={"Identify Hidden Risks Instantly"}>
          Don't get caught out by complex legal jargon. Legal Scan highlights potential risks,
          ambiguities, and unfavorable terms, presenting them in an easy-to-understand list so you
          know exactly what you're agreeing to.
        </InfoCol>

        <InfoCol title={"Sign with Confidence"}>
          Our user-friendly interface makes complex legal analysis accessible to everyone.
          Understand the implications of your contracts fully and sign with the confidence that
          comes from being well-informed.
        </InfoCol>
      </Row>
    </Container>
  );
}

export default Features;
